"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'voices.jane.description': '年轻、温暖、温和而友好的女性。',
};
